import _ from 'lodash'
import { GlobalStorage } from '@feedyou/schema'
import { Dictionary, parseJsonSafe } from '@feedyou/utils'

export function convertLegacyVariablesToGlobalStorages(
  legacyVariables: Dictionary<string, string>
): Dictionary<string, GlobalStorage> {
  return _.mapValues(legacyVariables, (value, key) => ({
    value,
    name: key,
    type: getValueType(value!),
    readonly: true,
    environmentSpecific: true
  }))
}

export function getValueType(
  value: string | number | object | Array<any> | boolean
): GlobalStorage['type'] {
  if (typeof value === 'string') {
    return 'string'
  }

  if (typeof value === 'number') {
    return 'number'
  }

  if (typeof value === 'boolean') {
    return 'boolean'
  }

  if (Array.isArray(value)) {
    return 'array'
  }

  return 'object'
}
